import React, { useState } from "react";
import axios from "axios";
//css
import "./DevicePage.css";
//components
import FetchLoader from "../../helpers/FetchLoader";
//properties
import { properties } from "../../helpers/properties";

const ReleaseDevice = ({ assignedDevice, fetchDevices, countryId, userSsoId, authToken }) => {
    const [isLoading, setIsLoading] = useState(false);
    const [Error, setError] = useState(false);

    const handleRelease = (selectedDeviceId) => {
        setIsLoading(true);
        axios.put(process.env.REACT_APP_API_URL + `/v1/locations/${countryId}/devices/${selectedDeviceId}/release/user/${userSsoId}`, '', {
            headers: { Authorization: `Bearer ${authToken}` }
        })
            .then((response) => {
                fetchDevices();
            })
            .catch((error) => {
                console.error("Error fetching devices:", error);
                setError(true);
                setIsLoading(false);
            });
    };

    return (
        <>
            <span className="device-info">
                <p>The device <span className="device-name">{assignedDevice.deviceName}</span> with serial number <span className="device-name">{assignedDevice.serialNumber}</span> is now assigned to you. You can begin collecting payments on this terminal.</p>
            </span>
            <div className="button-group">
                <button className="release-btn device-btn" onClick={() => handleRelease(assignedDevice.deviceId)}>
                    {isLoading ? <FetchLoader /> : <span>Release Device</span>}
                </button>
            </div>
            {Error && <div className="error-message">{properties.DEVICE_RELEASE_ERROR_MSG}</div>}
        </>
    );
};
export default ReleaseDevice;